import React, { useContext } from "react";
import facebookIcon from "../../../assets/elections/candidate-social/facebook@3x.png";
import mailIcon from "../../../assets/elections/candidate-social/mail@3x.png";
import twitterIcon from "../../../assets/elections/candidate-social/twitter@3x.png";
import websiteIcon from "../../../assets/elections/candidate-social/website@3x.png";
import Candidate from "../../../components/Election/Candidate";
import RadarChart from "../../../components/RadarChart";
import { I18nContext } from "../../../providers/i18n";
import linkOrVoid from "../../../utils/link-or-void";
import "./styles.scss";

const CandidateInfo = ({ label, value }) =>
  value && (
    <div className="candidate-info">
      <div className="candidate-info-item">
        <span className="candidate-info-label">{label}:</span>
        <span className="candidate-info-value">{value}</span>
      </div>
    </div>
  );

const CandidateProfile = ({ candidate, chartData, onBackButton }) => {
  const { t } = useContext(I18nContext);

  const userData = chartData.map(it => ({ value: it.value }));
  const candidateData = candidate.chartData.map(it => ({ value: it }));
  const labels = chartData.map(it => it.label);

  return (
    <div className="candidate-profile">
      <div className="candidate-profile-content">
        <div className="candidate-screen-header">
          <button onClick={onBackButton}>
            {"« " + t("elections.candidatesMatch.backButton")}
          </button>
          <h3 className="candidate-profile-title">
            {t("elections.candidatePage.title")}
          </h3>
        </div>
        <div className="candidate">
          <Candidate candidate={candidate} />
        </div>
        {candidate.hasData && (
          <div className="candidate-chart">
            <RadarChart
              labels={labels}
              chart1={userData}
              chart2={candidateData}
            />
            <div className="label-container">
              <div className="label-color" />
              <div className="label">{t("elections.candidatePage.me")}</div>
              <div className="label-color second" />
              <div className="label">
                {candidate.firstName} {candidate.lastName}
              </div>
            </div>
            <p className="smartvote-website-link">
              © www.smartvote.ch / www.sotomo.ch
            </p>
          </div>
        )}
      </div>
      <div className="candidate-social">
        {candidate.personalWebsite && (
          <a href={linkOrVoid(candidate.personalWebsite)}>
            <img src={websiteIcon} alt="facebook" />
          </a>
        )}

        {candidate.linkToTwitter && (
          <a href={linkOrVoid(candidate.linkToTwitter)}>
            <img src={facebookIcon} alt="facebook" />
          </a>
        )}
        {candidate.linkToFacebook && (
          <a href={linkOrVoid(candidate.linkToFacebook)}>
            <img src={twitterIcon} alt="twitter" />
          </a>
        )}
        {candidate.email && (
          <a href={linkOrVoid(candidate.email, true)}>
            <img src={mailIcon} alt="mail" />
          </a>
        )}
      </div>
      <CandidateInfo
        label={t("elections.candidatePage.currentOccupation")}
        value={candidate.occupation}
      />
      <CandidateInfo
        label={t("elections.candidatePage.education")}
        value={candidate.education || ""}
      />
      <CandidateInfo
        label={t("elections.candidatePage.hobbies")}
        value={candidate.hobbies}
      />
    </div>
  );
};

export default CandidateProfile;
